import { Component, OnInit, Input, OnChanges, forwardRef, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AuthService } from 'app/auth/services/auth.service';
import { uuid } from 'app/shared/utils/uuid';

@Component({
  selector: 'app-form-multi-input',
  templateUrl: './form-multi-input.component.html',
  styleUrls: ['./form-multi-input.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormMultiInputComponent),
      multi: true
    }
  ]
})
export class FormMultiInputComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() translation: any = {};
  @Input() label = '';
  @Input() name = '';
  @Input() taggable = false;
  @Input() tags: string[] = null;
  @Input() required = false;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() type = 'input';
  @Input() rows = 5;
  @Input() active = '';
  @Output() change = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Output() focus = new EventEmitter();

  @Output() activeLangChange: EventEmitter<string> = new EventEmitter<string>();

  id = 'a' + uuid();
  langs: any = [];
  primaryLang = '';
  model = '';
  activeLang = '';
  primaryValue = '';

  constructor(
    private authService: AuthService,
  ) { }

  propagateChange = (_: any) => { };

  ngOnInit() {
    this.getLangs();
  }

  ngOnChanges() {
    this.translation = this.translation || {};

    if (this.active === 'PRIMARY') {
      this.activeLang = this.primaryLang;
      this.onChangeLang(this.primaryLang);
    }

    if (this.isPrimaryLang()) {
      this.model = this.primaryValue;
    } else {
      this.model = this.translation[this.activeLang];
    }
  }

  isEmpty(lang = null) {
    if (this.isPrimaryLang(lang)) {
      return !this.primaryValue;
    } else {
      return !this.translation[lang];
    }
  }

  onBlur(e) {
    this.blur.emit(e);
  }

  onFocus(e) {
    this.focus.emit(e);
  }

  onChangeLang(lang) {
    this.activeLang = lang;

    if (this.isPrimaryLang()) {
      this.model = this.primaryValue;
      this.change.emit('');
    } else {
      this.model = this.translation[this.activeLang];
      this.change.emit(lang);
    }

  }

  onChangeValue(value) {
    if (this.isPrimaryLang()) {
      this.primaryValue = value;
      this.propagateChange(value);
    } else {
      Object.assign(this.translation, { [this.activeLang]: value });
    }
  }

  isPrimaryLang(lang = null) {
    if (lang) {
      return this.primaryLang === lang;
    } else {
      return this.primaryLang === this.activeLang;
    }
  }

  writeValue(value: any) {
    value = this.translation[this.primaryLang] ?? value;

    this.primaryValue = value;
    this.model = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  private getLangs() {
    this.authService.getAuthenticatedUser().subscribe((response: any) => {
      if (response) {
        const secondaries: any[] = response.program?.secondary_languages || [];
        const primary: string = response.program?.primary_language;
        const langs = [primary, ...secondaries];

        this.activeLang = primary;
        this.primaryLang = primary;
        // this.writeValue(this.translation[this.primaryLang] || '');

        if (langs.length > 1) {
          this.langs = langs.map((lang) => {
            const codes = lang.toUpperCase().split('-');
            const code = codes[0] === codes[1] ? codes[0] : codes[0] + '/' + codes[1];

            return {
              id: lang,
              name: code
            };
          });
        }
      }
    });
  }
}
